<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">{{ pagina }}</h4>
      </v-alert>
      <v-row style="margin-left: 4px">
        <v-col>
          <v-text-field
            v-on:keyup.enter="buscarDocumento()"
            label="Pesquisar por Ementa"
            v-model="filtro.ementa"
          />
        </v-col>
        <v-col cols="1">
          <v-text-field
            v-on:keyup.enter="buscarDocumento()"
            type="number"
            label="Número"
            v-model="filtro.numero"
          />
        </v-col>
        <v-col cols="1">
          <v-text-field
            v-on:keyup.enter="buscarDocumento()"
            type="number"
            label="Ano"
            v-model="filtro.ano"
          />
        </v-col>

        <v-col cols="3" style="margin-top: 1.1%">
          <v-select
            solo
            dense
            clearable
            v-model="filtro.tipoDocumentoId"
            :items="tiposDoc"
            item-text="nome"
            item-value="tipoDocumentoId"
            label="Tipo de Documento"
          ></v-select>
        </v-col>

        <v-col cols="2" style="margin-top: 1.8%">
          <v-btn
            color="primary"
            small
            depressed
            :loading="carregando"
            :disabled="carregando"
            @click="buscarDocumento()"
          >
            <v-icon small>fa-search</v-icon>
          </v-btn>

          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            @click="novo()"
            :disabled="!userHasPermission()"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>
            Novo
          </v-btn>
        </v-col>
      </v-row>

      <template>
        <v-data-table
          :headers="headers"
          :items="lista"
          :options.sync="options"
          :server-items-length="totalElements"
          :loading="carregando"
          :footer-props="{ itemsPerPageOptions: [10, 25, 50] }"
          class="elevation-1"
          no-results-text="A busca não trouxe resultados."
          no-data-text="A busca não trouxe resultados."
        >
          <template v-slot:loading>
            <LoadingSpinner text="Carregando documentos... aguarde." />
          </template>
          <template v-slot:item.dataInclusao="{ item }">
            {{ formatarData(item.dataInclusao) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <!-- TEMPLATE PARA PASSAR ITEM COMO PARAMETRO PARA AS FUNCOES -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <!-- TEMPLATE PARA ATIVAR TOOLTIP -->
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-icon :disabled="!userAdm()" small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </template>

      <v-dialog :retain-focus="false" v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >Confirma a exclusão do item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">
              Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
              >OK
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </app-layout>
</template>

<script>
import documentoService from "@/service/DocumentoService";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      deleteId: null,
      dialogDelete: false,
      filtro: {
        numero: null,
        ano: null,
        ementa: null,
        tipoDocumentoId: null,
        isJurisprudencia: false,
        isLegislacao: false,
      },
      tiposDoc: [],
      lista: [],
      totalElements: 0,
      carregando: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      //tiposDiario: [1,2,3,4,5,7,14,15,16,18], //tipos documento que vem do diário -> não cria nova pub.
      headers: [
        { text: "Cód.", value: "documentoId", sortable: false },
        { text: "Número", value: "numero", sortable: false },
        { text: "Ano", value: "ano", sortable: false },
        { text: "Tipo", value: "tipoDocumento.nome", sortable: false },
        { text: "Data de Publicação", value: "dataInclusao", sortable: false },
        { text: "Ações", value: "actions", align: "center", width: "8%" },
      ],
    };
  },
  methods: {
    novo() {
      this.$router.push("/documentos/" + this.$route.params.pagina + "/0");
    },
    editItem(item) {
      this.$router.push(
        "/documentos/" + this.$route.params.pagina + "/" + item.documentoId
      );
    },
    deleteItem(item) {
      this.deleteId = item.documentoId;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteId != null) {
        documentoService.excluir(this.deleteId).then(() => {
          this.carregarPagina();
        });
        this.deleteId = null;
      }
      this.closeDelete();
    },
    buscarDocumento() {
      // nova pesquisa: volta para a primeira página
      if (this.options.page !== 1) {
        this.options.page = 1; // o watch de options dispara a busca
      } else {
        this.carregarPagina();
      }
    },
    carregarPagina() {
      if (this.$route.params.pagina === "legislacao") {
        this.filtro.isLegislacao = true;
        this.filtro.isDeliberacao = false;
      }

      if (this.$route.params.pagina === "doc") {
        this.filtro.isDeliberacao = true;
        this.filtro.isLegislacao = false;
      }

      this.salvarFiltro();

      this.carregando = true;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      documentoService
        .buscarDocumentoFiltroPaginado(
          this.filtro,
          this.options.page - 1,
          this.options.itemsPerPage
        )
        .then((result) => {
          this.lista = result.content;
          this.totalElements = result.totalElements;
        })
        .finally(() => (this.carregando = false));
    },
    formatarData(data) {
      if (!data) {
        return "-";
      }
      const partes = data.split("-");
      return partes[2] + "/" + partes[1] + "/" + partes[0];
    },

    closeDelete() {
      this.dialogDelete = false;
      this.deleteId = null;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    salvarFiltro() {
      const filtroDocumento = JSON.stringify(this.filtro);
      if (this.$route.params.pagina == "legislacao") {
        localStorage.setItem("filtroLeg", filtroDocumento);
      }
      if (this.$route.params.pagina == "doc") {
        localStorage.setItem("filtroDoc", filtroDocumento);
      }
    },
    testeLocalStorage() {
      if (
        this.$route.params.pagina == "doc" &&
        localStorage.getItem("filtroDoc")
      ) {
        this.filtro = JSON.parse(localStorage.getItem("filtroDoc"));
      }
      if (
        this.$route.params.pagina == "legislacao" &&
        localStorage.getItem("filtroLeg")
      ) {
        this.filtro = JSON.parse(localStorage.getItem("filtroLeg"));
      }
    },
  },
  created() {
    // restaura o filtro salvo antes do v-data-table emitir o primeiro
    // update:options (que dispara a carga inicial pelo watch)
    this.testeLocalStorage();
  },
  mounted() {
    if (this.$route.params.pagina === "legislacao") {
      documentoService
        .findTiposLegislacao()
        .then((res) => (this.tiposDoc = res));
    } else {
      //documentoService.findTiposDocumento().then(res => this.tiposDoc = res);
      documentoService
        .findTiposDeliberacao()
        .then((res) => (this.tiposDoc = res));
    }
    /*
    if(this.$route.params.pagina === "deliberacoes"){
      documentoService.findTiposDeliberacao().then(res => this.tiposDoc = res);
    } */
  },

  computed: {
    pagina() {
      return this.$route.params.pagina == "legislacao"
        ? "Legislações"
        : "Documentos";
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    /* isAdm(){
      for (var grupo of this.$store.state.auth.user.grupos){
        if(grupo.nomeGrupo === 'Administradores'){
          return true
        }else
        return false
      }
    } */
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    options: {
      handler() {
        this.carregarPagina();
      },
      deep: true,
    },
  },
};
</script>

<style></style>
